import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const ROWS = [
  { label: 'Container origin',         value: 'Developer laptop · Not production pipeline',                       warn: true  },
  { label: 'Permission scope',         value: 'Write to payment config · Never exercised',                        warn: true  },
  { label: 'Duration in production',   value: '184 days',                                                         warn: true  },
  { label: 'Evidence status',          value: '◆ Complete · Cryptographically signed · Reconstructable',          warn: false },
];

export default function IncidentCard({ basePath = '/lens' }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      style={{
        background: '#0F1629',
        border: '1px solid #1E2A45',
        borderLeft: '3px solid #0D9488',
        borderRadius: 16,
        padding: 28,
      }}
      data-testid="incident-card"
    >
      {/* Header */}
      <div>
        <span style={{ color: '#F59E0B', fontSize: 9, fontFamily: 'JetBrains Mono, monospace', textTransform: 'uppercase', letterSpacing: '0.18em' }}>
          GOVERNANCE FAILURE · INV-2026-042
        </span>
        <h3 style={{ color: '#F8FAFC', fontSize: 18, fontWeight: 700, marginTop: 6, letterSpacing: '-0.01em' }}>
          Dev-origin container in production payments
        </h3>
        <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, lineHeight: 1.6 }}>
          Ran for 184 days before detection. Write access to payment configuration.
        </p>
      </div>

      {/* Contrast row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginTop: 20 }}>
        <div style={{ background: '#1a0a0a', border: '1px solid #3d1515', borderRadius: 10, padding: 16 }}>
          <div style={{ color: '#EF4444', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: 8, fontFamily: 'JetBrains Mono, monospace' }}>
            Without Apex Lens
          </div>
          <div style={{ color: '#F8FAFC', fontSize: 22, fontWeight: 800, fontFamily: 'JetBrains Mono, monospace' }}>127,000</div>
          <div style={{ color: '#94A3B8', fontSize: 11 }}>Security Hub findings</div>
          <div style={{ color: '#64748B', fontSize: 11, marginTop: 8, lineHeight: 1.5 }}>
            No reconstruction. No timeline. No governance answer.
          </div>
        </div>
        <div style={{ background: '#0a1a15', border: '1px solid #0D9488', borderRadius: 10, padding: 16 }}>
          <div style={{ color: '#0D9488', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: 8, fontFamily: 'JetBrains Mono, monospace' }}>
            With Apex Lens
          </div>
          <div style={{ color: '#F8FAFC', fontSize: 22, fontWeight: 800, fontFamily: 'JetBrains Mono, monospace' }}>9</div>
          <div style={{ color: '#94A3B8', fontSize: 11 }}>Governance actions</div>
          <div style={{ color: '#64748B', fontSize: 11, marginTop: 8, lineHeight: 1.5 }}>
            Complete reconstruction. Signed evidence. Audit-ready.
          </div>
        </div>
      </div>

      {/* Evidence rows */}
      <div style={{ marginTop: 16 }}>
        {ROWS.map((row) => (
          <div key={row.label} style={{
            display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
            borderTop: '1px solid #1E2A45', paddingTop: 10, marginTop: 10,
          }}>
            <span style={{ color: '#64748B', fontSize: 11, fontFamily: 'JetBrains Mono, monospace', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              {row.label}
            </span>
            <span style={{
              color: row.warn ? '#F59E0B' : '#10B981',
              fontSize: 11, fontFamily: 'JetBrains Mono, monospace', textAlign: 'right',
            }}>
              {row.value}
            </span>
          </div>
        ))}
      </div>

      {/* CTA */}
      <Link to={`${basePath}/investigations`} style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        marginTop: 20, color: '#0D9488', fontSize: 12, textDecoration: 'none',
      }} data-testid="incident-card-cta">
        View investigation <ArrowRight size={12} />
      </Link>
    </motion.div>
  );
}
